<template>
    <span style="display: none;" />
</template>

<script setup>
const generalStore = useGeneralStore();

const { activePalette } = storeToRefs(generalStore);

useHead({
    bodyAttrs: {
        class: computed(() => activePalette.value ? activePalette.value : 'palette--mma')
    }
});
</script>
